"use strict";

var React = require('react');

function ModalBody(props) {
  return React.createElement(
    "div",
    { className: "cf-modal__body" },
    props.children
  );
}

module.exports = ModalBody;